// @flow
import * as React from 'react';
import { connect } from "react-redux";
import styled from 'styled-components';
import * as _ from 'lodash';
import { Redirect } from 'react-router-dom';
import * as selectors from "../../modules/selectors";
import * as actions from '../../modules/actions';
import type { TPLeague } from "../../modules/types/league";

import {
	OneColumnLayout,
	PageTitle,
	AdsContainer,
	Ad,
} from '../../components';
import { LeagueManagerComponent } from '../../components/utils/LeagueManager/index';
import LeagueSettingsForm from './leagueSettings/LeaguesSettingsForm';

const PageTitleStyled = styled(PageTitle)`
	margin-top: 1em;
	margin-left: 1em;
`;

type Props = {
	fetchLeague: typeof actions.leagueDraft.showDraftLeague,
	rounds_list: Array<Object>,
	rounds_array: Array<Object>,
	handleSubmit: Function,
	league: TPLeague,
	league_show:  {
		error: string,
		league_id: number,
	},
	match: {
		params: {
			league_id: number,
		}
	},
	user_id: number,
}

class LeagueSettingsComponent extends React.Component<Props> {
	ifYouNotCommisioner() {
		const {
			league_show: {
				league_id
			},
			user_id,
			league: {
				commissioner,
			}
		} = this.props;

		return league_id && commissioner && user_id && commissioner !== user_id;
	}
	componentDidMount() {
		const { fetchLeague, match: { params : { league_id } } } = this.props;
		fetchLeague({ id: league_id });
	}

	render() {
		const {
			match: { params: { league_id } },
			league
		} = this.props;
		if(_.isEmpty(league) || !league.id) {
			return null;
		}

		if (this.ifYouNotCommisioner()) {
			return <Redirect to={`/league/${league_id}/about`} />;
		}

		return (
			<div>
				<AdsContainer>
					<Ad
						adUnit='settings'
						size='top'
					/>
				</AdsContainer>
				<LeagueManagerComponent from="update" league_id={league_id} league={league}>
					{({ rounds_list, rounds_array, handleSubmit, ...props }: Props) => (
						<OneColumnLayout>
							<PageTitleStyled>League Settings</PageTitleStyled>
							<LeagueSettingsForm
								{...props}
								rounds={rounds_list}
								onSubmit={handleSubmit}
							/>
						</OneColumnLayout>
					)}
				</LeagueManagerComponent>
				<AdsContainer>
					<Ad
						adUnit='settings'
						size='bottom'
					/>
				</AdsContainer>

			</div>
		);
	}
}

const mapStateToProps = (state, props) => ({
	league_show: state.leagues.show,
	user_id: state.user.data.id,
	league: selectors.leagueDraft.getLeague(state, props),
});

const mapDispatchToProps = {
	fetchLeague: actions.leagueDraft.showDraftLeague
};

export const LeagueSettings = connect(
	mapStateToProps,
	mapDispatchToProps,
)(LeagueSettingsComponent);

export default LeagueSettings;


// WEBPACK FOOTER //
// ./src/pages/league/LeagueSettings.js